import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconChevronUp = createIcon({
  displayName: 'IconChevronUp',
  path: [
    <path
      key="0"
      d="M20.29 16.71L12 8.41L3.70998 16.71L2.28998 15.29L12 5.59L21.71 15.29L20.29 16.71Z"
      fill="currentColor"
    />,
  ],
  viewBox: '0 0 24 24',
})
